module.exports = __webpack_public_path__ + "static/media/exclusao.2258885a.svg";